export default "__VITE_ASSET__BX6XahB7__"